<template>
    <div class="card" @click="tryLogin">
        <div>
            <div>{{ title }}</div>
            <div>{{ getCompetitionInfo }}</div>
        </div>
    </div>
</template>

<script>

import { mapMutations, mapGetters } from 'vuex';
import compMut from '../store/mutations/competition';

export default {
    name: "competition-card",
    props: {
        title: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true
        },
    },
    methods: {
        ...mapMutations([compMut.SETSELECTEDCOMPETITION]),
        tryLogin(){
            this.SETSELECTEDCOMPETITION(this.getCompetition);
            this.$router.push('/dashboard/login/');
        }
    },
    computed: {
        ...mapGetters(['Competitions']),
        getCompetition(){
            return this.Competitions.find(obj => { return obj.id == this.id});
        },
        getCompetitionInfo() {
            const comp = this.getCompetition;
            return `${comp.date} - ${comp.town || ''} ${comp.nation || ''}`;
        },
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    .card {
        border: solid 1px $seltec_color;
        border-top: 0px;
        width:100%;
        background-color:$prim_bg_color;
        height: $height_default;
        padding-left: $spacer_s / 2;
        font-size: 10px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        
        div {  
            div {                
                overflow: hidden;
                text-overflow: ellipsis;
            }          

             div:first-of-type {
                font-size: 14px;
                font-weight: bold;
            }
        }

        > div {            
            width: 85%;
            white-space: nowrap;
        }
    }

    .card:first-of-type {
        border-top: solid 1px $seltec_color;
    }
    
    .card:hover {
        background-color:$sec_color_dark;
        cursor: pointer;
    }

    .card:active {
        background-color:$seltec_color;
        cursor: pointer;
    }

    .card::after {
        font: normal normal normal 24px/1 "Material Design Icons";
        content:"\F0342";
        margin-left: auto;
        padding-right: 10px;
    }

    @media screen and (max-width: $body_max_width) {       
        .card {
            border:0px;
            
        border-bottom: solid 1px $seltec_color;
        }
    }
</style>